import Tilt from "react-tilt";

const WorkCard = (props) => {
  const title = props.content.split(":")
  return (

    <Tilt options={{ max: 30, scale: 1 }} className="card Tilt">
      <img draggable="false"  src={props.image} alt="Project" />
      <div class="card-content">
        <div className="tag">
          <h3>{props.title}</h3>
        </div>
        <div className="desc">
          {title.map(item => (<p>{item}</p>)) }
          <div className="btns">
            <a className="work-btn" href={props.live} target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-eye"></i> View
            </a>
            <a className="work-btn" href={props.github} target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-code"></i> Code
            </a>
          </div>
        </div>
      </div>
    </Tilt>
  );
};

export default WorkCard;
